module.exports = __webpack_public_path__ + "img/pin_drop_24px_outlined.6cf6782a.svg";